import { Tag } from '@otomoro/components/shared/Tag'
import React from 'react'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { AppText } from '@otomoro/components/shared/AppText'
import { styles, TextHighlightVariants } from './TextHighlight.css'

interface TextHighlightProps extends TextHighlightVariants {
	tag: string | undefined
	introduction: PortableTextObject | undefined
}

export const TextHighlight: React.FC<TextHighlightProps> = ({ tag, introduction }) => {
	const introductionComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" weight="medium" color="black" size="intro" className="mt-1">
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
		types: {
      reference: ({ value }) => {
        return value.svg && (
					<span
						className='w-[13rem] md:w-[16.5rem] inline-block'
						dangerouslySetInnerHTML={{ __html: value.svg }}
					/>
				)
      },
    },
	} as PortableTextComponents

	const { inner } = styles()

	return (
		<section>
			<div className={inner()}>
				<Tag as="strong">{tag}</Tag>
				<PortableText
					value={introduction as PortableTextObject}
					components={introductionComponents}
				/>
			</div>
		</section>
	)
}
